import Head from '../../layouts/Head';
import ContactContainer from '../../containers/Contact';
import Footer from '../../layouts/Footer';

const Contact = () => {


  return (
	<>
		<Head Title='Contact Us' />
		<ContactContainer />
		<Footer />
	</>
  );
}

export default Contact;

